import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError, handleResponseMessage } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import barInfoService from './barInfoService';
import { barInfoListActions } from './barInfoSlice';
import { BarInfo } from './models/IBarGuideInfo';

function* getListOfBarGuideInfo() {
  try {
    const response: CommonResponse<Array<BarInfo>> = yield call(barInfoService.getBarInformationList);
    yield put(barInfoListActions.fetchListOfBarInfoSuccess(response));
  } catch (e) {
    yield put(barInfoListActions.fetchListOfBarInfoFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* deleteBarInfo(action: PayloadAction<Array<number>>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<BarInfo>> = yield call(barInfoService.deleteBarInformationList, params);
    yield put(barInfoListActions.deleteBarInfoSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

function* restoreBarInfo(action: PayloadAction<Array<number>>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<BarInfo>> = yield call(barInfoService.restoreBarInformationList, params);
    yield put(barInfoListActions.restoreBarInfoSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

function* updateBarInfo(action: PayloadAction<BarInfo>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<BarInfo>> = yield call(barInfoService.updateBarInformation, params);
    yield put(barInfoListActions.updateBarInfoSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

function* addNewBarInfo(action: PayloadAction<BarInfo>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<BarInfo>> = yield call(barInfoService.addNewBarInformation, params);
    yield put(barInfoListActions.addNewBarInfoSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

export default function* barInfoListSaga() {
  yield takeLatest(barInfoListActions.fetchListOfBarInfo.type, getListOfBarGuideInfo);
  yield takeLatest(barInfoListActions.deleteBarInfo.type, deleteBarInfo);
  yield takeLatest(barInfoListActions.restoreBarInfo.type, restoreBarInfo);
  yield takeLatest(barInfoListActions.updateBarInfo.type, updateBarInfo);
  yield takeLatest(barInfoListActions.addNewBarInfo.type, addNewBarInfo);
}
